export default "__VITE_ASSET__DeIqsLe0__"